import React from 'react'
import { Context } from './Context'

/**
 *
 */
export const withProduct = (Component) => (props) => {
  const { product } = React.useContext(Context)
  return <Component product={product} {...props} />
}
